import cloneDeep from 'lodash.clonedeep';
import { CollectionFunctionInterfaceFormData, CollectionFunctionCountryCode } from 'data/collectionFunction/collectionFunction.types';

// eslint-disable-next-line import/prefer-default-export
export function handleInterfacesFieldUpdate(
  interfaceFormDataList: CollectionFunctionInterfaceFormData[] | undefined,
  interfaceId: string | undefined,
  fieldName: keyof CollectionFunctionInterfaceFormData,
  value: unknown,
): CollectionFunctionInterfaceFormData[] | undefined {
  const clonedInterfaceFormDataList = cloneDeep(interfaceFormDataList);

  return clonedInterfaceFormDataList?.map((interfaceFormData) => {
    if (interfaceFormData.id === interfaceId) {
      return handleInterfaceFieldUpdate(interfaceFormData, fieldName, value);
    }

    return interfaceFormData;
  });
}

function handleInterfaceFieldUpdate(
  interfaceFormData: CollectionFunctionInterfaceFormData,
  fieldName: keyof CollectionFunctionInterfaceFormData,
  fieldValue: unknown,
) {
  setInterfaceFieldValue(interfaceFormData, fieldName, fieldValue);

  if (fieldName === 'version') {
    interfaceFormData = setInterfaceValuesForSelectedVersion(
      interfaceFormData,
    );
  }

  if (fieldName === 'countryCode') {
    interfaceFormData = setInterfaceValuesForSelectedCountry(
      interfaceFormData,
      fieldValue as CollectionFunctionCountryCode,
    );
  }

  return interfaceFormData;
}

function setInterfaceFieldValue(
  interfaceFormData: any,
  fieldName: string,
  value: unknown,
): CollectionFunctionInterfaceFormData {
  interfaceFormData[fieldName] = value;

  return interfaceFormData;
}

function setInterfaceValuesForSelectedVersion(
  interfaceFormData: CollectionFunctionInterfaceFormData,
): CollectionFunctionInterfaceFormData {

  if (interfaceFormData.countryCode != null) {
    setInterfaceValuesForSelectedCountry(interfaceFormData, 'NONE');
  }

  return interfaceFormData;
}

function setInterfaceValuesForSelectedCountry(
  interfaceFormData: CollectionFunctionInterfaceFormData,
  fieldValue: CollectionFunctionCountryCode,
): CollectionFunctionInterfaceFormData {

  if (interfaceFormData.pldEncType == null || interfaceFormData.pldEncKey == null) {
    return interfaceFormData;
  }

  const interfaceVersion = interfaceFormData.version;

  if ((fieldValue === 'TR' && interfaceVersion !== '2.5.1') || fieldValue === 'NL') {
    interfaceFormData.pldEncType = true;

  } else {
    interfaceFormData.pldEncType = false;
    interfaceFormData.pldEncKey = '';
  }

  return interfaceFormData;
}
